import { connect } from 'react-redux'

import { addRentalReputationBackUrl } from 'app/shared_components/actions'
import { fetchApplication } from 'app/sm/apply/apply_actions'
import { fetchEmployers, removeEmployer } from 'app/sm/employment/actions'
import EmploymentHistoryList from 'app/sm/employment/employment_history_list'
import {
  changeReputationPreference,
  fetchCompleteness,
  retrieveReputationPreference,
} from 'app/sm/rental_reputation/actions'

const mapStateToProps = ({
  Employment,
  session,
  Shared,
  apply,
  RentalReputation,
}) => ({
  employers: Employment.employers,
  error: Employment.error,
  clicked: Employment.clicked,
  currentUser: session.currentUser,
  backUrl: Shared.backUrl,
  property: apply.property,
  reputationPreference: RentalReputation.preference,
  completeness: RentalReputation.completeness,
  applicationDetails: apply.application,
  isQLDForm22: apply.isQLDForm22,
})

const mapDispatchToProps = (dispatch) => ({
  fetchEmployers: (propertyGUID) => dispatch(fetchEmployers(propertyGUID)),
  removeEmployer: (id, success, fail) =>
    dispatch(removeEmployer(id, false, success, fail)),
  retrieveReputationPreference: () => dispatch(retrieveReputationPreference()),
  changeReputationPreference: (preference) =>
    dispatch(changeReputationPreference(preference)),
  addRentalReputationBackUrl: (rentalBackUrl) =>
    dispatch(addRentalReputationBackUrl(rentalBackUrl)),
  fetchCompleteness: () => dispatch(fetchCompleteness()),
  fetchApplication: (applicationId) =>
    dispatch(fetchApplication(applicationId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmploymentHistoryList)
